const initialState = {
  products: [],
  statusLoad: false,
  cart: [],
  prodItem: null,
  modalBox: null
}

export default initialState;

